/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { CreateFragmentUploadMutationRequest, CreateFragmentUploadMutationResponse, CreateFragmentUploadPathParams } from "../models/CreateFragmentUpload";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createFragmentUpload } from "../axios/createFragmentUpload";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createFragmentUploadMutationKey = () => ["social-export-api", { url: '/upload/fragments/:fragment' }] as const

export type CreateFragmentUploadMutationKey = ReturnType<typeof createFragmentUploadMutationKey>

export function createFragmentUploadMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateFragmentUploadMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createFragmentUploadMutationKey()
        return mutationOptions<CreateFragmentUploadMutationResponse, ResponseErrorConfig<Error>, {fragment: CreateFragmentUploadPathParams["fragment"], data: CreateFragmentUploadMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ fragment, data }) => {
            return createFragmentUpload(fragment, data, config)
          },
        })

}

/**
 * @summary Start upload of fragment media to platform
 * {@link /upload/fragments/:fragment}
 */
export function useCreateFragmentUpload<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateFragmentUploadMutationResponse, ResponseErrorConfig<Error>, {fragment: CreateFragmentUploadPathParams["fragment"], data: CreateFragmentUploadMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateFragmentUploadMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createFragmentUploadMutationKey()

          const baseOptions = createFragmentUploadMutationOptions(config) as UseMutationOptions<CreateFragmentUploadMutationResponse, ResponseErrorConfig<Error>, {fragment: CreateFragmentUploadPathParams["fragment"], data: CreateFragmentUploadMutationRequest}, TContext>
          

          return useMutation<CreateFragmentUploadMutationResponse, ResponseErrorConfig<Error>, {fragment: CreateFragmentUploadPathParams["fragment"], data: CreateFragmentUploadMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateFragmentUploadMutationResponse, ResponseErrorConfig<Error>, {fragment: CreateFragmentUploadPathParams["fragment"], data: CreateFragmentUploadMutationRequest}, TContext>
      
}